<template>
  <div>
    <Main
      ref="main"
      :loading="loading"
      :disabled="disabled"
      @reload="getData"
      :disabledPrint="disabledPrint"
    >
      <div slot="header">
        <div class="d-flex mt-2">
          <div class="side-frame"></div>
          <div>
            <span style="font-size: 14px; color: #606266">
              {{ $l('table_header_title') || '产品明细列表' }}
            </span>
            <el-divider direction="vertical" v-if="!disabled"></el-divider>
            <b-button
              size="sm"
              class="ml-2"
              variant="outline-success"
              @click="chooseAmzSku()"
              v-if="!disabled"
            >
              {{ $l('btn_chooseAmzSku') || '选择产品' }}
            </b-button>
          </div>
        </div>
      </div>
      <template #toolbar_btn v-if="disabled">
        <SortFieldsPopover
          v-model="sortFields"
          funcListName="hxFtyInvInNoticeDetailList"
          style="margin-right: 0.8em;"
          @change="getData"
        />
      </template>
    </Main>

    <ChoosePurchaseSku
      :visible.sync="choosePurchaseSkuVisible"
      :scmCode="scmCode"
      @confirm="skuConfirm"
    />
  </div>
</template>
<script>
import Main from './main.vue'
import ChoosePurchaseSku from '../choose-purchase-sku'
import SortFieldsPopover from '@/views/ecom/components/sort-fields-popover'
import { divideDown, multiply } from '@/libs/util.number.js'
export default {
  components: { Main, ChoosePurchaseSku, SortFieldsPopover },
  props: {
    disabled: { type: Boolean, default: false },
    hxFtyNoticeInCode: { type: String, default: '' },
    scmCode: { type: String, default: '' },
    disabledPrint: { type: Boolean, default: false },
  },
  data() {
    return {
      loading: false,
      sortFields: [],
      choosePurchaseSkuVisible: false,
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    async getData() {
      if (!this.hxFtyNoticeInCode) return
      this.loading = true
      const res = await this.$api
        .ecomHxFtyNoticeInDetailListApi({
          hxFtyNoticeInCode: this.hxFtyNoticeInCode,
          sortFields: this.sortFields,
        })
        .catch(() => false)
      this.loading = false
      const data = res?.body?.data || []
      this.$refs.main.setData(data)
    },
    chooseAmzSku() {
      if (this.scmCode) return (this.choosePurchaseSkuVisible = true)
      this.$message.warning(
        this.$l('tips_chooseAmzSku_Scm') || '请先选择入库通知单供应商！'
      )
    },
    async skuConfirm(data) {
      if (!data || !data.length) return
      const tableData = this.getTableData()

      if (tableData && tableData.length) {
        data = data.filter(
          (i) =>
            !tableData
              .map((j) => `${j.hxPurchaseCode || ''}${j.hxSkuCode || ''}`)
              .includes(`${i.hxPurchaseCode || ''}${i.hxSkuCode || ''}`)
        )
      }
      if (!data || !data.length) return
      data = data.map((item) => {
        const {
          purchasePrice: ftyPrice,
          inCtnQty,
          invQty,
          ctnGrossWeight,
          ctnCbm,
        } = item
        const ctnQty = divideDown(invQty, inCtnQty, 0)
        const goodsQty = multiply(ctnQty, inCtnQty)
        const subAmount = multiply(goodsQty, ftyPrice)
        const subGrossWeight = multiply(ctnQty, ctnGrossWeight)
        const subCbm = multiply(ctnQty, ctnCbm)

        return {
          ...item,
          ftyPrice,
          ctnQty,
          goodsQty,
          subAmount,
          subGrossWeight,
          subCbm,
        }
      })
      this.$refs.main.insertAt(data)
    },
    validate() {
      return this.$refs.main.validate()
    },
    getTableData() {
      return this.$refs.main.getTableData()
    },
  },
}
</script>
<style lang="scss" scoped>
.side-frame {
  padding: 1px 5px;
  border-left: 3px solid $color-primary;
  height: 20px;
  margin-top: 3px;
}
</style>
